import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { FileDownloadService } from 'src/app/core/services/file-download.service';

@Component({
    selector: 'app-recover-recording-dialog',
    templateUrl: './recover-recording-dialog.component.html',
    styleUrls: ['./recover-recording-dialog.component.scss']
})
export class RecoverRecordingDialogComponent implements OnInit {
    dates: string[] = [];
    loading = false;
    downloading = false;
    error: string | null = null;

    constructor(
        public dialogRef: MatDialogRef<RecoverRecordingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public patient: any,
        private http: HttpClient,
        private snackBar: MatSnackBar,
        private fileDownloadService: FileDownloadService
    ) { }

    ngOnInit(): void {
        this.fetchDates();
    }

    fetchDates(): void {
        this.loading = true;
        const token = localStorage.getItem('token');
        const sub = this.http.get<string[]>(`${environment.API_URL}/api/recordings/${this.patient.id}/dates`, { headers: { Authorization: `Bearer ${token}` } })
            .subscribe({
                next: dates => {
                    this.dates = dates.map(date => date || 'Unknown Filename');;
                    this.loading = false;
                    sub.unsubscribe();
                },
                error: err => {
                    this.error = 'Failed to fetch dates or no recordings available.';
                    this.loading = false;
                    sub.unsubscribe();
                }
            });
    }

    download(date: string): void {
        this.downloading = true;
        const token = localStorage.getItem('token');
        const url = `${environment.API_URL}/api/recordings/${this.patient.id}/${date}/download`;
        this.http.get(url, {
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob'
        }).subscribe({
            next: async blob => {
                const fileName = `${this.patient.name} ${this.patient.surname} - ${date}.wav`;
                await this.fileDownloadService.download(blob, fileName);
                this.downloading = false;
            },
            error: () => {
                this.snackBar.open(`Failed to download for ${date}`, 'Close', { duration: 3000, panelClass: ['themed-snackbar'] });
                this.downloading = false;
            }
        });
    }
    close(): void {
        this.dialogRef.close();
    }
}
